// src/pages/Marketplace/shared/useUnassignedBusinesses.ts
import { useCallback, useEffect, useState } from 'react';
import type { MarketBusiness, Paginated } from './types';

export function useUnassignedBusinesses(apiUrl: string, accessToken: string | null, pageSize = 25) {
  const [items, setItems] = useState<MarketBusiness[]>([]);
  const [cursor, setCursor] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPage = useCallback(async (nextCursor: string | null) => {
    if (!apiUrl || !accessToken) return;
    setLoading(true); setError(null);
    try {
      const qs = new URLSearchParams({ marketAssigned: 'false', limit: String(pageSize) });
      if (nextCursor) qs.set('cursor', nextCursor);
      const res = await fetch(`${apiUrl}/admin/businesses?${qs}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (!res.ok) throw new Error(`GET unassigned ${res.status}`);
      const body = (await res.json()) as Paginated<MarketBusiness>;
      setItems((prev) => (nextCursor ? [...prev, ...body.items] : body.items));
      setCursor(body.nextCursor);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Unknown error');
    } finally { setLoading(false); }
  }, [apiUrl, accessToken, pageSize]);

  useEffect(() => { fetchPage(null); }, [fetchPage]);

  return { items, cursor, loading, error,
    loadMore: () => cursor && fetchPage(cursor),
    refetch: () => fetchPage(null) };
}
